<template>
  <section
    class="container"
    v-loading.fullscreen.lock="loading"
    element-loading-text="fetching details.."
    element-loading-background="white"
  >
    <section class="productDetails" id="product-details-page">
      <el-row type="flex" justify="center" v-loading.fullscreen.lock="loading">
        <el-col :lg="20">
          <el-row>
            <el-col :lg="12" :xl="12" v-if="singleProduct">
              <div class="product-details-left">
                <div class="md-card-media">
                  <!-- big slider -->
                  <swiper
                    :options="swiperOptionTop"
                    class="gallery-top"
                    ref="swiperTop"
                  >
                    <swiper-slide
                      class="slide-1"
                      v-for="item in singleProduct.images"
                      :key="item.id"
                    >
                      <img
                        :src="item.image"
                        :alt="singleProduct.name"
                        class="img-swiper-top"
                      />
                    </swiper-slide>
                    <div
                      class="swiper-button-next swiper-button-white"
                      slot="button-next"
                    ></div>
                    <div
                      class="swiper-button-prev swiper-button-white"
                      slot="button-prev"
                    ></div>
                  </swiper>
                  <!-- ./ big slider -->
                  <!-- thumbnail slider -->
                  <swiper
                    v-if="singleProduct.images.length > 1"
                    :options="swiperOptionThumbs"
                    class="gallery-thumbs"
                    ref="swiperThumbs"
                  >
                    <swiper-slide
                      v-for="item in singleProduct.images"
                      :key="item.id"
                    >
                      <img
                        :src="item.image"
                        :alt="singleProduct.name"
                        class="img-swiper-thummb"
                      />
                    </swiper-slide>
                  </swiper>
                  <!-- ./ thumbnail slider -->
                </div>

                <div class="card-social-link">
                  <ul>
                    <li>
                      <a href="#"></a>
                    </li>
                  </ul>
                </div>
              </div>
            </el-col>
            <!-- product details -->
            <el-col :lg="12" :xl="12">
              <div class="product-details-right">
                <h1 class="product-name">{{ singleProduct.name }}</h1>
                <p class="price"></p>
                <div class="product-specifications">
                  <div class="each-specification">
                    <el-row>
                      <el-col :lg="12">
                        <p class="title">Model Number</p>
                      </el-col>
                      <el-col :lg="12">
                        <p class="content">{{ singleProduct.sku }}</p>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="each-specification">
                    <el-row>
                      <el-col :lg="12">
                        <p class="title">Category</p>
                      </el-col>
                      <el-col :lg="12">
                        <p class="content">
                          {{ singleProduct.category.display_name }}
                        </p>
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    class="each-specification"
                    v-if="singleProduct.freight_charges"
                  >
                    <el-row>
                      <el-col :lg="12">
                        <p class="title">Freight Charges</p>
                      </el-col>
                      <el-col :lg="12">
                        <p class="content">
                          {{ singleProduct.display_freight_charges }}
                        </p>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <AddToCartComponent :product="singleProduct" />
              </div>
            </el-col>
          </el-row>
          <el-row>
            <!-- ./ product details -->
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <el-tabs v-model="activeTab" class="product-spec-tabs">
                <!-- product description -->
                <el-tab-pane label="PRODUCT DESCRIPTION" name="description">
                  <p
                    class="line-height-40"
                    v-html="singleProduct.description"
                  ></p>
                </el-tab-pane>
                <!-- ./ product description -->
              </el-tabs>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </section>
  </section>
</template>

<script>
import LayoutDefault from "@/layouts/LayoutDefault";
import { mapGetters } from "vuex";
import progress from "nprogress";
import AddToCartComponent from "../../components/cart/AddToCartComponent";

export default {
  components: { AddToCartComponent },
  data() {
    return {
      loading: false,
      activeTab: "description",
      singleProduct: {},
      delivery_pin: "",
      swiperOptionTop: {
        spaceBetween: 20,
        slidesPerView: 1,
        autoplay: {
          delay: 2500,
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionThumbs: {
        spaceBetween: 90,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
        autoplay: {
          delay: 2500,
        },
        loop: false,
      },
    };
  },
  watch: {
    async $route() {
      await this.fetchSingleProduct();
    },
  },
  computed: {
    ...mapGetters("products", ["getSingleProduct"]),
    slug() {
      return this.$route.params.slug;
    },
  },
  async created() {
    this.$emit("update:layout", LayoutDefault);
    this.$root.$emit("closenav", false);

    this.$forceUpdate();
    await this.fetchSingleProduct();
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper;
      const swiperThumbs = this.$refs.swiperThumbs.swiper;
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  },
  methods: {
    async fetchSingleProduct() {
      this.loading = true;
      progress.start();
      await this.$store.dispatch("products/fetchSingleProduct", this.slug);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      progress.done();
      this.singleProduct = this.getSingleProduct;
      this.loading = false;
    },
    async addToCart() {
      progress.start();
      await this.$store.dispatch("cart/add", this.getSingleProduct);
      progress.done();
    },
    placeOrder() {
      this.$router.push({
        name: "checkout",
        params: { slug: this.slug },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.productDetails {
  margin-top: 25px;
  margin-bottom: 30px;

  .product-name {
    font-weight: bold;
    font-size: 18px;
  }

  .product-details-left {
    .gallery-top {
      height: 80% !important;
      width: 100%;

      .img-swiper-top {
        max-width: 100%;
        margin: 0 auto;
      }

      /*padding: 20px 0 0 30px;*/
    }

    .gallery-thumbs {
      height: 20% !important;
      box-sizing: border-box;
      padding: 10px 0;

      .img-swiper-thumb {
        max-width: 100px;
      }

      img {
        width: 150px;
        margin: 30px;
      }
    }

    .gallery-thumbs .swiper-slide {
      width: 25%;
      height: 100%;
      opacity: 0.4;
    }

    .gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }

  .product-details-right {
    padding-left: 25px;

    .each-specification {
      margin-bottom: 20px;

      .title {
        font-size: 15px;
        color: #7b7a7a;
      }

      .content {
        font-size: 14px;
        color: #313131;
        line-height: 25px;
      }
    }
  }

  .el-tabs__nav {
    .el-tabs__item {
      color: #333 !important;
      font-family: "Gotham-light", sans-serif;
    }
  }
}

.w60 {
  width: 60%;
}

.mb20 {
  margin-bottom: 20px;
}

.check-btn {
  background: transparent;
  border: none;
  color: #11233f;
}
</style>
